import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, $, Slot } from "@builder.io/qwik";
import { modalContextId } from "./modal-context.qwik.mjs";
const HModalClose = component$((props) => {
  const context = useContext(modalContextId);
  const handleClick$ = $(() => {
    context.showSig.value = false;
  });
  return /* @__PURE__ */ jsx("button", {
    onClick$: [
      handleClick$,
      props.onClick$
    ],
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HModalClose
};
